import { Link } from "react-router-dom";

export default function HeroBanner() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20cinematic%20newsroom%20atmosphere%20with%20warm%20spotlight%20effects%20and%20floating%20social%20media%20icons%2C%20moody%20orange%20and%20crimson%20lighting%2C%20abstract%20data%20streams%2C%20modern%20digital%20media%20concept%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20breaking%20news%20aesthetic%2C%20dramatic%20shadows&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="吃瓜网 - 全网最全吃瓜爆料平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 pt-20">
          <div className="lg:w-3/5">
            <div className="flex items-center gap-2 mb-6">
              <div className="flex -space-x-2">
                <img src="https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20portrait%20circle%20crop%2C%20warm%20tone%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish" alt="" className="w-10 h-10 rounded-full border-2 border-white/80 object-cover" />
                <img src="https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20portrait%20circle%20crop%2C%20warm%20tone%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish" alt="" className="w-10 h-10 rounded-full border-2 border-white/80 object-cover" />
                <img src="https://readdy.ai/api/search-image?query=Chinese%20adult%20avatar%20portrait%20circle%20crop%2C%20warm%20tone%2C%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish" alt="" className="w-10 h-10 rounded-full border-2 border-white/80 object-cover" />
              </div>
              <span className="text-white/80 text-sm">百万吃瓜群众在线</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-tight tracking-tight">
              <span className="block">全网最全</span>
              <span className="block font-light text-3xl md:text-5xl lg:text-6xl">实时吃瓜爆料平台</span>
            </h1>

            <Link
              to="/category/exclusive"
              className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-950 font-medium rounded-full hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              立即吃瓜
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-2/5 lg:pb-4">
            <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-md">
              汇聚吃瓜网每日大赛，实时追踪娱乐圈、网红圈、社会热点第一手爆料。独家黑料、深度八卦，一切尽在吃瓜网 —— 免费吃瓜第一站，正能量不打烊。
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}